import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { createCostCenter } from "../../Redux/actions/InventroyAction";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Sidebar from "../Sidebar/Sidebar";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import {
  Container,
  Row,
  Col,
  Table,
  Form,
  Modal,
  Dropdown,
  Button,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faPenAlt,
  faTrashCan,
  faAdd,
} from "@fortawesome/free-solid-svg-icons";
import pdfIcon from "../../Assets/icons/pdf.png";
import excelIcon from "../../Assets/icons/excel.png";
import printIcon from "../../Assets/icons/print.png";
import "../InventoryManagement/Inventory.css";

const CostCenter = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [costCenterName, setCostCenterName] = useState("");
  const { loading, message, error } = useSelector(
    (state) => state.createCostCenter
  );

  useEffect(() => {
    if (message === undefined && error !== undefined) {
      alert(error.non_field_errors);
    }
    if (message !== undefined) {
      setCostCenterName("");
      successAlert();
    }
  }, [message, error]);
  const successAlert = () => {
    toast.info("New Cost-Center-ID Created Successfully", {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  };
  const CreateCostCenter = (e) => {
    console.log(costCenterName);
    e.preventDefault();
    dispatch(createCostCenter(costCenterName));
  };
  //console.log(error.non_field_errors);
  console.log(message);
  return (
    <div>
      <Sidebar></Sidebar>
      <div className="mainContent">
        <ToastContainer />
        <Header></Header>
        <Container fluid>
          <Row className="ms-2 me-2">
            <Col lg={6}>
              <h4 className="product-heading">Cost Center</h4>
              <p className="product-paragraph">
                {" "}
                Cost Center <FontAwesomeIcon
                  icon={faChevronRight}
                  size="xs"
                />{" "}
                Cost Center List
              </p>
            </Col>
          </Row>
          <div
            className="mb-4 p-3 card product-card container-view"
            style={{ minHeight: "50vh" }}
          >
            <Row>
              <Col xl={4} className="mb-3">
                <h3 className="category-heading">Create Cost Center</h3>
                <Form className="pt-4 pe-3" onSubmit={CreateCostCenter}>
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label className="pb-1">Cost Center Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="e.g: cost center name "
                      value={costCenterName}
                      onChange={(e) => setCostCenterName(e.target.value)}
                      required
                    />
                  </Form.Group>
                  <Button className="mt-3 add-email-btn border-0" type="submit">
                    <FontAwesomeIcon
                      icon={faAdd}
                      style={{ paddingRight: "0.4rem" }}
                    />
                    Create Cost Center
                  </Button>
                </Form>
              </Col>
              <Col className="mt-5" xl={8}>
                <Table className="mt-2" responsive>
                  <thead className="text-center table-header">
                    <tr>
                      <th>Sl No.</th>
                      <th>Cost Center</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody className="text-center">
                    <tr>
                      <td>01</td>
                      <td>RCPS-530CS</td>
                      <td>
                        <button
                          className="border-0"
                          style={{
                            background: "#1C449C",
                            color: "white",
                            fontSize: "14px",
                            borderRadius: "5px",
                            width: "80px",
                            cursor: "not-allowed",
                          }}
                        >
                          Active
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td>02</td>
                      <td>RCPS-530CS</td>
                      <td>
                        <button
                          className="border-0"
                          style={{
                            background: "rgba(0, 117, 191, 0.1)",
                            color: "#1B2850",
                            fontSize: "14px",
                            borderRadius: "5px",
                            width: "80px",
                            cursor: "not-allowed",
                            //opacity: "0",
                          }}
                        >
                          Inactive
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
      <Footer></Footer>
    </div>
  );
};

export default CostCenter;
